export default __webpack_public_path__ + "static/media/ΚΕΝ_ΦΑ.5502840e.png";